import { integrationFeatureApi } from "./redux";


export const IntegrationFeatureMiddlewares = [
  integrationFeatureApi.middleware,
];

export const IntegrationFeatureReducers = {
  [integrationFeatureApi.reducerPath]: integrationFeatureApi.reducer,
};